import { generateThemeOverride } from '@botpress/webchat'
import { useMemo } from 'react'
import { Avatar } from '~/elements'
import { getUseConfigStore } from '~/features/webchat/stores/useConfigStore'
import { cn } from '~/utils'

type Props = {
  workspaceId: string
  botId: string
  themeOverride?: 'light' | 'dark'
  className?: string
}

export const ConversationThumbnail = ({ workspaceId, botId, themeOverride, className }: Props) => {
  const useConfigStore = useMemo(() => getUseConfigStore({ botId, workspaceId }), [botId, workspaceId])
  const webchatTheme = useConfigStore((state) => state.themeMode)

  const botAvatar = useConfigStore((state) => state.botAvatar)
  const botName = useConfigStore((state) => state.botName)
  const color = useConfigStore((state) => state.color)
  const fontFamily = useConfigStore((state) => state.fontFamily)
  const radius = useConfigStore((state) => state.radius)
  const themeMode = themeOverride ?? webchatTheme
  const variant = useConfigStore((state) => state.variant)
  const headerVariant = useConfigStore((state) => state.headerVariant)

  const themeProps = { color, fontFamily, radius, themeMode, variant, headerVariant }
  const styleOverride = generateThemeOverride({ ...themeProps })

  return (
    <div
      className={cn(
        className,
        'flex h-5/6 w-3/4 flex-col items-start justify-start rounded-t-xl bg-[--bpGray-50] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]'
      )}
      style={styleOverride}
    >
      <div className="flex h-12 items-center justify-start gap-2 self-stretch rounded-t-xl bg-[--header-bg] px-4 py-2 backdrop-blur-sm">
        {botAvatar ? (
          <Avatar pictureUrl={botAvatar} className="h-6 w-6" />
        ) : (
          <div className="h-6 w-6 rounded-full bg-neutral-100" />
        )}
        <div className="justify-start truncate text-xs font-medium text-[--header-title]">{botName}</div>
      </div>
      <div className="flex flex-1 flex-col items-center justify-start gap-10 self-stretch p-4">
        <img
          className="h-14 w-14 rounded-full"
          src={
            botAvatar
              ? botAvatar
              : 'https://mediafiles.botpress.dev/899504c9-6b09-4de9-a474-87ee0f56b6c0/integration/icon.svg'
          }
        />
        <div className="flex w-full flex-col gap-2">
          <div className="h-7 w-3/5 max-w-24 self-end rounded-t-lg rounded-bl-lg bg-[--message-bg]" />
          <div className="h-7 w-3/5 max-w-24 self-start rounded-t-lg rounded-br-lg bg-[--bpGray-200]" />
        </div>
      </div>
    </div>
  )
}
